"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ListModel_1 = require("@twii/core/lib/model/ListModel");
var ListingServiceContext_1 = require("../service/ListingServiceContext");
var ListingRelatedListModel = /** @class */ (function (_super) {
    __extends(ListingRelatedListModel, _super);
    function ListingRelatedListModel(listing) {
        var _this = _super.call(this) || this;
        _this._listing = listing;
        return _this;
    }
    Object.defineProperty(ListingRelatedListModel.prototype, "listingService", {
        get: function () {
            return this._listingService || ListingServiceContext_1.ListingServiceContext.value;
        },
        set: function (value) {
            this._listingService = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingRelatedListModel.prototype, "listing", {
        get: function () {
            return this._listing;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], ListingRelatedListModel.prototype, "_listing", void 0);
    __decorate([
        mobx_1.computed
    ], ListingRelatedListModel.prototype, "listing", null);
    return ListingRelatedListModel;
}(ListModel_1.ListModel));
exports.ListingRelatedListModel = ListingRelatedListModel;
